import styled from 'styled-components';
import {
    colorBlack,
    colorWhite,
    mediaMd,
    mediaXs,
} from 'theme/theme-helper-selectors';

export const AccordionTitle = styled.p`
    font-size: 42px;
    line-height: 42px;
    font-weight: 400;
    color: ${colorWhite};

    @media (${mediaMd}) {
        font-size: 32px;
        line-height: 36px;
    }

    @media (${mediaXs}) {
        font-size: 24px;
        line-height: 42px;
    }
`;

export const AccordionDescription = styled.p`
    font-size: 24px;
    line-height: 27px;
    font-weight: 300;
    max-width: 80%;

    @media (${mediaMd}) {
        font-size: 21px;
        line-height: 24px;
    }

    @media (${mediaXs}) {
        font-size: 16px;
        line-height: 18px;
    }
`;

export const MoreLink = styled.span`
    font-weight: 500;
    font-size: 21px;
    line-height: 24px;
    color: ${colorBlack};

    @media (${mediaMd}) {
        font-size: 16px;
        line-height: 20px;
    }

    @media (${mediaXs}) {
        font-size: 16px;
        line-height: 18px;

        font-weight: 400;
    }
`;

export const MoreLinkContainer = styled.div`
    display: flex;
    width: 100%;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    gap: 6px;
    margin: 50px 0 0 0;
    cursor: pointer;

    @media (${mediaMd}) {
        margin: 40px 0 0 0;
    }

    @media (${mediaXs}) {
        margin: 15px 0 0 0;
    }

    &:hover {
        ${MoreLink} {
            color: rgba(61, 232, 202, 1);
        }

        svg {
            fill: rgba(61, 232, 202, 1);
        }
    }
`;
